// Mode Bac à sable (formation) — état global léger côté client.
// Quand actif, un en-tête X-Pitboard-Sandbox est ajouté à tous les appels backend
// (voir fetchInterceptor.js + services/api.js), et le backend bascule la base.
// Réservé aux admins internes (le backend ignore l'en-tête pour les autres rôles).

const KEY = 'pitboard_sandbox';
const EVT = 'pitboard-sandbox-change';
export const SANDBOX_HEADER = 'X-Pitboard-Sandbox';

export function isSandboxActive() {
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function setSandboxActive(active) {
  try {
    if (active) window.localStorage.setItem(KEY, '1');
    else window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new CustomEvent(EVT, { detail: !!active }));
  } catch {
    /* ignore */
  }
}

export function onSandboxChange(callback) {
  const handler = () => callback(isSandboxActive());
  window.addEventListener(EVT, handler);
  window.addEventListener('storage', handler);
  return () => {
    window.removeEventListener(EVT, handler);
    window.removeEventListener('storage', handler);
  };
}
